{
    "save": "Enregistrer",
    "cancel": "Annuler",
    "back": "Retour",
    "next": "Suivant",
    "submit": "Envoyer",
    "loading": "Chargement...",
    "language": "Langue",
    "languageDescription": "Choisissez la langue des menus, des boutons et des rappels.",
    "profile": {
        "title": "Profil",
        "description": "Gérez votre profil et vos préférences",
        "contactDetails": "Coordonnées",
        "languageGroup": "Langue",
        "otherActions": "Autres actions",
        "changePassword": "Modifier le mot de passe",
        "logout": "Se déconnecter",
        "incompleteTitle": "Profil incomplet",
        "incompleteMessage": "Pour utiliser Patient Watch, veuillez d'abord compléter votre profil en renseignant tous les champs signalés comme manquants."
    },
    "nav": {
        "diaries": "Journaux"
    }
}
